// removed by extract-text-webpack-plugin
module.exports = {"page":"containers-Main-style__page__1KRsk","code-example":"containers-Main-style__code-example__1qvoe","codeExample":"containers-Main-style__code-example__1qvoe","screenshot":"containers-Main-style__screenshot__pE2zc","main":"containers-Main-style__main__3_Lu3","content":"containers-Main-style__content__nSizl","loading":"containers-Main-style__loading__2rAKg"};


//////////////////
// WEBPACK FOOTER
// ./containers/Main/style.scss
// module id = 607
// module chunks = 0